<p class="divider">
  <span class="text">Filter</span
  ><span class="line"></span>
</p>
<nz-skeleton [nzActive]="true" [nzLoading]="isCRUD" [nzParagraph]="{ rows: 2 }">
  <filter-builder *ngIf="customerFilter.filter" [filter]="customerFilter.filter" [persist]="persistFilter"></filter-builder>
</nz-skeleton>
<div class="preview-content">
  <nz-table
    [nzLoading]="vehiclesPreviewLoading"
    [nzData]="vehicleResults"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzSize]="'small'"
  >
    <thead>
    <tr>
      <th>Order</th>
      <th>Kunde</th>
      <th>Kunden ID</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of vehicleResults">
      <td>
        <span>
          <img src="https://cdn.imagin.studio/getImage?customer=yoma-de&make={{item.vehicle_brand}}&modelFamily={{item.vehicle_model}}&angle=28&zoomType=fullscreen&paintdescription={{text2Slug(item.vehicle_color)}}" width="80"/>
        </span>
        <span style="margin-left: 6px;">
          {{ item.vehicle_model }}
        </span>
      </td>
      <td>{{ item.cardealer_customer_name }}</td>
      <td>{{ item.cardealer_customer_id }}</td>
    </tr>
    </tbody>
  </nz-table>
</div>

<ng-template #tplDeleteModal>
  <p>
    Wenn Sie eine Großkunde löschen, werden alle Einstellungen entfernt und der
    Benutzerzugriff wird gesperrt. Die monatliche Gebühr für diese Ansicht wird
    für den nächsten Abrechnungszyklus entfernt.
  </p>
  <p nz-typography nzType="danger">
    <strong>Dies kann nicht rückgängig gemacht werden.</strong>
  </p>
</ng-template>


